import React from 'react'
import gql from 'graphql-tag'
import { Mutation } from 'react-apollo'
import { logError, logSuccess } from '../toaster'
import { ContrastFormattedMessage } from '../contrast-formatted-message'

export const updateSensitiveDataMaskingSettingsMutation = gql`
  mutation UpdateSensitiveDataMaskingSettings(
    $organizationID: ID!
    $maskAttackVector: Boolean!
    $maskHttpBody: Boolean!
  ) {
    updateSensitiveDataMaskingSettings(
      input: {
        organizationID: $organizationID
        maskAttackVector: $maskAttackVector
        maskHttpBody: $maskHttpBody
      }
    ) {
      _placeholder
    }
  }
`

export interface UpdateSensitiveDataMaskingSettingsArgs {
  readonly organizationID: string
  readonly maskAttackVector: boolean
  readonly maskHttpBody: boolean
}

export function UpdateSensitiveDataMaskingSettingsMutation({
  children
}: {
  readonly children: (
    updateSensitiveDataMaskingSettings: (
      variables: UpdateSensitiveDataMaskingSettingsArgs
    ) => Promise<any>
  ) => React.ReactNode
}) {
  return (
    <Mutation<{}, UpdateSensitiveDataMaskingSettingsArgs>
      mutation={updateSensitiveDataMaskingSettingsMutation}
    >
      {(updateSensitiveDataMaskingSettings) => {
        return (
          <ContrastFormattedMessage id="detail_sensitiveData_updateSensitiveDataMaskingSettingsSuccess">
            {(successMessage) => {
              return (
                <ContrastFormattedMessage id="detail_sensitiveData_updateSensitiveDataMaskingSettingsError">
                  {(saveErrorMessage) => {
                    return children(
                      async (
                        variables: UpdateSensitiveDataMaskingSettingsArgs
                      ) => {
                        try {
                          await updateSensitiveDataMaskingSettings({
                            variables
                          }).then(() => {
                            logSuccess(successMessage)
                          })
                        } catch (error) {
                          logError(saveErrorMessage)
                          // Re-throw the error so the form knows it didn't save successfully
                          throw error
                        }
                      }
                    )
                  }}
                </ContrastFormattedMessage>
              )
            }}
          </ContrastFormattedMessage>
        )
      }}
    </Mutation>
  )
}
